<template>
  <div class="page">
    <PageHeader>
      Проекты
    </PageHeader>
    <div class="content">
      <el-card shadow="always" :body-style="{ padding: '20px' }" v-loading="loading">
        <div v-if="projects.docs">
          <el-table :data="projects.docs" @sort-change="handleSortChange"
            :default-sort="{ prop: '_id', order: 'descending' }" :row-class-name="tableRowClassName" border stripe>
            <el-table-column sortable="custom" prop="_id" label="ID" width="90">
              <template v-slot="scope">
                <i v-if="scope.row.isNew" class="el-icon-document-add"></i>
                {{ scope.row._id.slice(-6) }}
              </template>
            </el-table-column>
            <el-table-column sortable="custom" prop="name" label="Заголовок">
            </el-table-column>
            <el-table-column sortable="custom" prop="value" label="Название">
            </el-table-column>
            <el-table-column sortable="custom" prop="bestchangeName" label="Название на Bestchange">
            </el-table-column>
            <el-table-column sortable="custom" prop="option" label="Используется">
              <template v-slot="scope">
                <el-switch v-model="scope.row.option" @change="handleOptionChange(scope.row)"></el-switch>
              </template>
            </el-table-column>
            <el-table-column v-if="session.type <= -1" fixed="right" label="Действия" width="150">
              <template v-slot="scope">
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-edit"
                  @click="handleEditRow(scope.row)"
                ></el-button>
                <el-tooltip placement="top">
                  <div slot="content">Удалить</div>
                  <el-button size="small" icon="el-icon-delete" @click="handleDeleteItem(scope.row._id)"></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @current-change="handlePageChange"
            :current-page.sync="projects.page"
            :page-size="projects.limit"
            layout="sizes, prev, pager, next, jumper"
            :total="projects.totalDocs"
          ></el-pagination>
          <el-drawer
            :title="`Редактируем строку`"
            :before-close="handleCloseEditPopup"
            :visible.sync="showEditRowPopup"
            direction="ltr"
            ref="editrowpopup"
          >
          <el-card shadow="always" :body-style="{ padding: '20px' }">
          <el-form :model="rowEdit">
            <el-form-item label="Заголовок">
                <el-input v-model="rowEdit.name"></el-input>
              </el-form-item>
              <el-form-item label="Название">
                <el-input v-model="rowEdit.value"></el-input>
              </el-form-item>
              <el-form-item label="Название на Bestchange">
                <el-input v-model="rowEdit.bestchangeName"></el-input>
              </el-form-item>
            <div class="demo-drawer__footer">
          <el-button @click="cancelRowEdit">Отмена</el-button>
          <el-button
            type="primary"
            @click="handleUpdateRow"
            :loading="loadingEditRow"
            >{{ loadingEditRow ? "Сохраняю ..." : "Сохранить" }}</el-button
          >
        </div>
      </el-form>
        </el-card>
          </el-drawer>
        </div>
        <el-collapse >
          <el-collapse-item name="1" >
            <template slot="title">
              <i class="header-icon el-icon-plus"></i>
              Добавить
            </template>
            <el-form :model="newProject" ref="form" label-width="80px" :inline="false" size="normal">
              <el-form-item label="Заголовок">
                <el-input v-model="newProject.projectTitle"></el-input>
              </el-form-item>
              <el-form-item label="Название">
                <el-input v-model="newProject.projectName"></el-input>
              </el-form-item>
              <el-form-item label="Название на Bestchange">
                <el-input v-model="newProject.projectBestchangeName"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="addItem">Добавить</el-button>
                <el-button @click="resetForm">Очистить</el-button>
              </el-form-item>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </el-card>
    </div>
  </div>
</template>
<script>
import {
  getProjects,
  deleteProjects,
  updateProjectsRow,
  addProject
} from "@/api";
import { mapState, mapActions, mapGetters } from "vuex";
import PageHeader from "../../ui/PageHeader.vue";
export default {
  components: { PageHeader },
  name: "ProjectsPage",
  data: () => ({
    loading: true,
    rowEdit: {},
    projects: [],
    newProject: {
      projectName: "",
      projectTitle: "",
      projectBestchangeName: "",
    },
    loadingEditRow: false,
    showEditRowPopup: false,
    page: 1,
    limit: 10,
    sort: "-_id"
  }),
  computed: {
    ...mapState("auth", ["session"])
  },
  methods: {
    async handleOptionChange(row) {
    // Обработка изменения значения чекбокса
    await updateProjectsRow(row)
    console.log('Новое значение: ', row);
  },
    resetForm() {
      this.newProject = {
      projectName: "",
      projectTitle: "",
      projectBestchangeName: "",
    }
  },
  async addItem() {
    console.log("sas")
      try {
        const data = {
          ...this.newProject
        };
        console.log(data)
        const resp = await addProject(data);
        await this.getProjects();
        this.resetForm();
        return this.$notify.success({
          title: "Успех",
        });
      } catch (error) {
        console.log(error);
        this.handleResponseError(error);
      }
    },
    async handleUpdateRow(){
      console.log('this.sad = ',this.rowEdit)
        this.loadingEditRow = true;
        const { data } = await updateProjectsRow(this.rowEdit);
        if(data){
          this.loadingEditRow = false;
        }
        await this.getProjects();
        this.showEditRowPopup = false;
    },
    cancelRowEdit() {
      this.rowEdit = {};
      this.loadingEditRow = false;
      this.showEditRowPopup = false;
    },
    handleEditRow(row) {
      console.log(row)
      this.rowEdit = { ...row };
      this.showEditRowPopup = true;
    },
    handleCloseEditPopup(done) {
      this.showEditRowPopup = false;
    },
    async getProjects() {
      try {
        this.loading = true;
        const { data } = await getProjects({
          page: this.page,
          limit: this.limit,
          sort: this.sort
        });
        if (data.status) this.projects = data.result;
      } catch (error) {
        this.handleResponseError(error);
      } finally {
        this.loading = false;
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isNew) {
        return "new-row";
      }
      return "";
    },
    async handleDeleteItem(id) {
      let message = "Вы точно хотите удалить проект?";
      try {
        await this.$confirm(message, "Внимание!", {
          confirmButtonText: "Удалить",
          cancelButtonText: "Отменить",
          type: "warning"
        });
        await deleteProjects(id);
        await this.getProjects();
        this.$message({
          type: "success",
          message: `Тип успешно удален успешно удален`
        });
      } catch (error) {
        this.$message({
          type: "info",
          message: "Удаление отменено"
        });
      }
    },
    async handleSortChange(sortData) {
      this.sort =
        sortData.order === "ascending"
          ? sortData.prop
          : sortData.order === "descending"
            ? `-${sortData.prop}`
            : "";
      await this.getProjects();
    },
    async handlePageChange(page) {
      this.page = page;
      await this.getProjects();
    },
  },
  async mounted() {
    await this.getProjects();
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/Projects/index.vue